import type { Slicer } from '@swf/core/store';

import type { SportsMyBetsState } from './types';

export const selectors = (slice: Slicer<SportsMyBetsState>) => ({
  isFetching: () => slice((state) => state.isFetching),
  isErroneous: () => slice((state) => state.isErroneous),
  bets: () => slice((state) => state.bets),
  cashoutQuotes: () => slice((state) => state.cashoutQuotes),
  cashedOut: () => slice((state) => state.cashedOut),
  moreAvailable: () => slice((state) => state.moreAvailable)
});
